import React, { useEffect, useState, useMemo } from "react";
import {
  FormControl,
  MenuItem,
  Select,
  Typography,
  InputLabel,
} from "@mui/material";
import { fetchVerificationCodes, getPreauthData } from "../action";
import { useDispatch, useSelector } from "react-redux";
import styled from "styled-components";
import { useTranslation } from "react-i18next";
import { cleanVerificationCode } from "../store/actions/exampleAction";

const Content = styled(Typography)`
  margin-bottom: 0.5rem;
`;
const VerificationPicker = ({
  input,
  value,
  reset,
  userHealthFacilityFullPath,
  withLabel = true,
  label = null,
  required = false,
  verificationWithoutBiometry = false,
  allRegions,
  region,
  meta,
  error,
  hfUuid,
  insureeVerification,
  ...props
}) => {
  const [selectedValue, setSelectedValue] = useState();
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const hfid = useSelector(
    (state) =>
      state?.profileReducer?.currentUserResponseData?.i_user?.health_facility_id
  );
  useEffect(() => {

    if (hfUuid) {
      dispatch(fetchVerificationCodes(hfUuid, hfid));
    } else {
      dispatch(cleanVerificationCode())
    }
  }, [hfUuid]);

  useEffect(() => {
    if (insureeVerification) {
      dispatch(getPreauthData(hfUuid, insureeVerification.verificationCode))
    }
  }, [insureeVerification]);


  const handleChange = (event) => {
    const selectedRegion = event.target.value;
    setSelectedValue(selectedRegion);
  };

  const VerificationCode = useSelector(
    (state) => state?.fosaReducer?.VerificationCode
  );

  return (
    <>
      <Content>
        <Typography required={required} color="#666666">
          {label}
          {required ? "*" : ""}
        </Typography>
      </Content>
      <FormControl fullWidth>
        <Select
          value={value}
          onChange={handleChange}
          displayEmpty
          required={required}
          size="small"
          error={meta && meta.touched && meta.error && error}
          {...input}
          {...props}
        >
          <MenuItem disabled value="">
            <em>{t("Select")}</em>
          </MenuItem>
          {(hfUuid && VerificationCode) &&
            VerificationCode
              .filter(verification => (
                verification.isClinicalVerification !== verificationWithoutBiometry
              ))
              .map((region) => (
                <MenuItem key={region.id} value={region}>
                  {region.verificationCode}
                </MenuItem>
              ))}
        </Select>
        {meta && meta.touched && meta.error ? (
          <Typography color="red" fontSize={".8rem"} align={"center"}>
            {error}
          </Typography>
        ) : (
          ""
        )}
      </FormControl>
    </>
  );
};

export default VerificationPicker;
